import { canUserPerformAction } from "access-roles/general-functions";
import { MISSION_BACKUP, MISSION_FEE } from "access-roles/roles";

export const enableBackupModal = ({ roles, missionIsBackupable }) =>
  canUserPerformAction({
    userRoles: roles,
    requiredRoles: MISSION_BACKUP.ROLE_CREATE_MISSION_BACKUP,
  }) && missionIsBackupable;

export const enableTwisterButton = ({ roles, missionIsBackupable }) =>
  canUserPerformAction({
    userRoles: roles,
    requiredRoles: MISSION_BACKUP.ROLE_CREATE_MISSION_BACKUP,
  }) && !missionIsBackupable;

export const enableMissionFee = ({ roles }) =>
  canUserPerformAction({
    userRoles: roles,
    requiredRoles: MISSION_FEE.ROLE_GET_MISSION_FEE,
  });
